import React from 'react';

const Notifications = () => {
  return (
    <div style={{ padding: '20px', borderRadius: '10px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
      <h3>Notifications</h3>
      <p>View and manage notifications.</p>
      <ul>
        <li>
          <strong>New User Registered</strong>
          <p>John Doe has registered as a new user.</p>
        </li>
        <li>
          <strong>System Update Available</strong>
          <p>A new version of the system is available for update.</p>
        </li>
      </ul>
      <button style={{ backgroundColor: '#fb9678', color: '#fff', border: 'none', padding: '10px 15px', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}>Mark All as Read</button>
    </div>
  );
};

export default Notifications;
